export default "__VITE_ASSET__e01d598d__"